// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import DocumentMeta from 'react-document-meta'

// Internal Dependencies:
import PageEvents from './PageEvents'
import Recaptchas from 'components/Recaptchas/Recaptchas'
import Content from './Content'

// Redux:
import { getPageData } from 'actions/page'
import { closeSearch } from 'actions/search'

class Page extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		const { match, type, dispatch } = this.props
		const { params, path } = match
		const isAppended = this.props.pageOverride ? true : false
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false

		// Fetch new content data:
		if ( '/' == path ) {
			this.update( 'page', 'home', false )
		} else if ( ! isAppended && params.slug ) {
			this.update( type, params.slug, archivePageNumber )
		}

		dispatch( closeSearch() )
	}

	componentDidUpdate( prevProps ) {
		if ( ! this.props.match ) {
			return
		}

		const { match, type, dispatch } = this.props
		const { params, path } = match
		const isAppended = this.props.pageOverride ? true : false
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false
		const prevArchivePageNumber = prevParams.archivePageNumber ? prevParams.archivePageNumber : false

		if ( ! isAppended &&
			( type != prevProps.type || params.slug != prevParams.slug || archivePageNumber != prevArchivePageNumber )
		) {
			this.update( type, params.slug, archivePageNumber )

			dispatch( closeSearch() )
		}
	}

	update = ( type, slug, archivePageNumber ) => {
		const { history, dispatch } = this.props
		const locationHash = history.location.hash.slice( 1 )
		const isAppended = this.props.pageOverride ? true : false

		// Scroll to the top when not jumping to an anchor:
		if ( ! locationHash && ! isAppended ) {
			window.scrollTo( 0, 0 )
		}

		dispatch(
			getPageData( {
				type: type,
				slug: slug,
				archivePageNumber: archivePageNumber
			} )
		)
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { match, currentlyViewedPage } = this.props
		const isAppended = this.props.pageOverride ? true : false
		const page = isAppended ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		let relativeUrl = match.url

		if ( relativeUrl.charAt( 0 ) === '/' ) {
			relativeUrl = relativeUrl.slice( 1 )
		}

		const meta = {
			title: currentlyViewedPage.title.raw,
			description: currentlyViewedPage.description,
			canonical: siteData.site_url + relativeUrl,
			meta: {
				'og:url': siteData.site_url + '/' + relativeUrl,
				'og:title': currentlyViewedPage.title.raw,
				'og:description': currentlyViewedPage.description
			}
		}

		if ( currentlyViewedPage && currentlyViewedPage.featured_image ) {
			meta['meta']['og:image'] = currentlyViewedPage.featured_image.url
		}

		const pageContent = page.html_override ? (
			<div className="content-custom-wrap" dangerouslySetInnerHTML={ { __html: page.html_override } }></div>
		) : (
			<div>
				<Content pageOverride={ this.props.pageOverride } />
			</div>
		)

		return (
			<div className="primary-content-inner primary-content-is-ready">
				<DocumentMeta { ...meta } />
				<PageEvents />

				{ pageContent }

				<Recaptchas match={ this.props.match } />
			</div>
		)
	}

	render() {
		if ( this.props.isLoading ) {
			return this.renderLoading()
		} else {
			return this.renderContent()
		}
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected,
		currentlyViewedPage: state.page.currentlyViewedPage
	}
}

export default connect( mapStateToProps )( Page )
